/* @flow */
import * as React from 'react';
import Dialog from 'components/Dialog.jsx';
import BoxBody from 'components/BoxBody.jsx';
import AvatarEditorModal from 'components/AvatarEditorModal.jsx';
import WebcamAvatarShooter from 'components/WebcamAvatarShooter.jsx';

type Props = {
  onSuccess: Function,
  uploadRequest: Function,
  loadThumbnail: Function,
  fileContextKey: string,
  onRequestHide?: Function,
};

type State = {
  view: 'webcam' | 'editor',
  image: ?string,
};

class WebcamAvatarModal extends React.Component<Props, State> {
  props: Props;

  state: State = {
    view: 'webcam',
    image: null,
  };

  handlePictureTaken = (image: string) => {
    this.setState({ image, view: 'editor' });
  };

  renderEditor() {
    if (!this.state.image) {
      return null;
    }

    return (
      <AvatarEditorModal
        filename="me.png"
        image={this.state.image}
        onSuccess={this.props.onSuccess}
        onRequestHide={this.props.onRequestHide}
        loadThumbnail={this.props.loadThumbnail}
        uploadRequest={this.props.uploadRequest}
        fileContextKey={this.props.fileContextKey}
      />
    );
  }

  renderWebcam() {
    return (
      <Dialog size="small" onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <WebcamAvatarShooter onPictureTaken={this.handlePictureTaken} />
        </BoxBody>
      </Dialog>
    );
  }

  render() {
    if (this.state.view === 'webcam') {
      return this.renderWebcam();
    } else if (this.state.view === 'editor') {
      return this.renderEditor();
    }

    return null;
  }
}

export default WebcamAvatarModal;
